jQuery(document).ready(function ($) {
  // console.log('AJAX endpoint is:', ajaxurl.ajax_url);
  $(".Image_carousal .wp-block-gallery").slick({
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  jQuery(".testimonial-slider").slick({
    dots: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 8000,
    slidesToShow: 1,
    adaptiveHeight: true,
  });

  setTimeout(function () {
    function getQueryParam(param) {
      var urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(param);
    }

    var categoryFromUrl = getQueryParam("category");
    if (categoryFromUrl) {
      var matchingButton = jQuery(
        "button[data-category='" + categoryFromUrl + "']"
      ); // Using jQuery instead of $
      if (matchingButton.length) {
        matchingButton.trigger("click");
      }
    }
    // console.log('Category from URL:', categoryFromUrl);
  }, 1000);

  $(".category_filter button").on("click", function () {
    $(".category_filter button").removeClass("active");
    $(this).addClass("active");

    var category = $(this).data("category");

    $.ajax({
      url: ajaxurl.ajax_url,
      type: "POST",
      data: {
        action: "filter_posts",
        category: category,
      },
      success: function (response) {
        $(".blog_posts").html(response);
        if ($(".blog-post").length <= 3) {
          $(".post_pagination").hide();
        } else {
          $(".post_pagination").show();
        }
      },
    });
  });

  $("#search-form").on("submit", function (e) {
    e.preventDefault();

    var searchTerm = $("#search-input").val();

    $.ajax({
      url: ajaxurl.ajax_url,
      type: "POST",
      data: {
        action: "filter_posts",
        search: searchTerm,
      },
      success: function (response) {
        $(".blog_posts").html(response);

        if ($(".blog-post").length <= 3) {
          $(".post_pagination").hide();
        } else {
          $(".post_pagination").show();
        }
      },
    });
  });

  jQuery(".menu-item-has-children").on("click", function (e) {
    if (jQuery(e.target).is("a") || jQuery(e.target).closest("a").length) {
      return;
    }
    const dropdown = $(this).find(".dropdown-menu").first();
    dropdown.toggleClass("show");
  });
  jQuery(".menu-item-has-children > a").each(function () {
    jQuery(this).removeAttr("data-toggle aria-haspopup aria-expanded");
  });
  jQuery(".menu-item-has-children > a").on("click", function () {});

  let scrolling = false;
  $(window).scroll(function () {
    let s = scrolling;
    scrolling = $(this).scrollTop() > 0;
    if (s !== scrolling) {
      handleDesktopMenuHover();
    }
  });

  function handleDesktopMenuHover() {
    if (window.innerWidth > 990) {
      let headerHeight = $("header").outerHeight() || 0;
      let adminBarHeight = $("#wpadminbar").outerHeight() || 0;

      if (scrolling) {
        adminBarHeight = 0;
      }

      let totalOffset = headerHeight + adminBarHeight + 2;
      $(".dropdown-menu").css({
        top: totalOffset + "px",
      });
      jQuery(".menu-item-has-children").on("mouseenter", function () {
        jQuery(this).find(".dropdown-menu").first().addClass("show");
      });

      jQuery(".menu-item-has-children").on("mouseleave", function () {
        jQuery(this).find(".dropdown-menu").first().removeClass("show");
      });
    } else {
      jQuery(".menu-item-has-children").off("mouseenter mouseleave");
      jQuery(".dropdown-menu").removeClass("show");
    }
  }
  handleDesktopMenuHover();
  jQuery(window).on("resize", function () {
    handleDesktopMenuHover();
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const triggers = document.querySelectorAll(".id_popup_trigger");
  const popups = document.querySelectorAll(".id_popup_content");
  triggers.forEach((trigger, index) => {
    trigger.addEventListener("click", function () {
      const popup = popups[index];

      if (popup) {
        popup.classList.add("popup-visible");
        // Prevent multiple close buttons
        if (!popup.querySelector(".popup-close-btn")) {
          const closeBtn = document.createElement("span");
          closeBtn.className = "popup-close-btn";
          closeBtn.innerHTML = "&times;";
          closeBtn.style.cursor = "pointer";

          popup.appendChild(closeBtn);

          closeBtn.addEventListener("click", function () {
            popup.classList.remove("popup-visible");
          });
        }
      }
    });
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const memberCards = document.querySelectorAll(".member_card_popup");
  const popup = document.getElementById("mainPopup");
  const popupHeaderH3 = popup.querySelector(".popup_header h3");
  const popupHeaderP = popup.querySelector(".popup_header p");
  const popupImage = popup.querySelector(".popup_image");
  const popupFooter = popup.querySelector(".popup_footer");
  const popupClose = popup.querySelector(".popup_close");
  const leftArrow = popup.querySelector(".popup_arrow.left");
  const rightArrow = popup.querySelector(".popup_arrow.right");

  let currentIndex = 0;
  const members = Array.from(memberCards).map((card) => {
    const imgEl = card.querySelector("img");
    const h3El = card.querySelector("h3");
    const pEl = card.querySelector("p");

    return {
      image: imgEl ? imgEl.src : "",
      name: h3El ? h3El.innerText : "",
      title: pEl ? pEl.innerText : "",
    };
  });
  popupFooter.innerHTML = "";
  members.forEach((m, index) => {
    if (!m.image) return;
    const thumb = document.createElement("img");
    thumb.src = m.image;
    thumb.alt = m.name || "Member";
    thumb.dataset.index = index;
    thumb.addEventListener("click", () => showMember(index));
    popupFooter.appendChild(thumb);
  });
  function showMember(index) {
    const member = members[index];
    if (!member) return;
    currentIndex = index;
    popupHeaderH3.textContent = member.name || "";
    popupHeaderP.textContent = member.title || "";
    popupImage.innerHTML = member.image
      ? `<img src="${member.image}" alt="${member.name || "Member"}">`
      : "";
    popupFooter.querySelectorAll("img").forEach((img) => {
      img.classList.toggle("popup_active_img", img.dataset.index == index);
    });
    memberCards.forEach((card, i) => {
      card.classList.toggle("popup_active", i === index);
    });
  }
  memberCards.forEach((card, index) => {
    card.addEventListener("click", () => {
      popup.classList.add("active");
      document.body.style.overflow = "hidden";
      showMember(index);
    });
  });
  leftArrow.addEventListener("click", () => {
    const prevIndex = (currentIndex - 1 + members.length) % members.length;
    showMember(prevIndex);
  });

  rightArrow.addEventListener("click", () => {
    const nextIndex = (currentIndex + 1) % members.length;
    showMember(nextIndex);
  });

  document.addEventListener("keydown", (e) => {
    if (!popup.classList.contains("active")) return;
    if (e.key === "ArrowLeft") {
      const prevIndex = (currentIndex - 1 + members.length) % members.length;
      showMember(prevIndex);
    }
    if (e.key === "ArrowRight") {
      const nextIndex = (currentIndex + 1) % members.length;
      showMember(nextIndex);
    }
    if (e.key === "Escape") {
      popup.classList.remove("active");
      document.body.style.overflow = "";
    }
  });

  popupClose.addEventListener("click", () => {
    popup.classList.remove("active");
    document.body.style.overflow = "";
  });

  popup.addEventListener("click", (e) => {
    if (e.target === popup) popup.classList.remove("active");
  });
});
